import { jsx as _jsx } from "react/jsx-runtime";
export function getBoxes(nodes, options) {
    const boxes = [];
    appendBoxes(nodes, boxes, options);
    return boxes;
}
function appendBoxes(nodes, boxes, options = {}) {
    const { getID } = options;
    for (const node of nodes) {
        boxes.push(_jsx("g", { id: getID ? getID(node) : undefined, transform: `translate(${node.position.x} ${node.position.y})`, children: node.element }, boxes.length));
        if (node.children) {
            appendBoxes(node.children, boxes, options);
        }
    }
}
//# sourceMappingURL=getBoxes.js.map